import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  login: false,
  register: false,
  modalType: false
};

// getters
export const getters = {
  login: state => state.login,
  register: state => state.register,
  universal: state => state.login || state.register,
  modalType: state => state.register ? 'register' : 'login'
};

// mutations
export const mutations = {
  
  [types.SHOW_LOGIN_SUCCESS] (state) {
    state.login = true;
    state.register = false;
  },
  
  [types.SHOW_LOGIN_FAILURE] (state) {
    state.login = false;
    state.register = false;
  },
  
  [types.CLOSE_LOGIN_SUCCESS] (state) {
    state.login = false;
    state.register = false;
  },
  
  [types.CLOSE_LOGIN_FAILURE] (state) {
    state.login = false;
    state.register = false;
  },
  
  [types.SHOW_REGISTER_SUCCESS] (state) {
    state.login = false;
    state.register = true;
  },
  
  [types.SHOW_REGISTER_FAILURE] (state) {
    state.login = false;
    state.register = false;
  },
  
  [types.CLOSE_REGISTER_SUCCESS] (state) {
    state.login = false;
    state.register = false;
  },
  
  [types.CLOSE_REGISTER_FAILURE] (state) {
    state.login = false;
    state.register = false;
  },
  
  [types.INIT_LOGIN_SUCCESS] (state) {
    state.login = false;
  },
  
  [types.INIT_REGISTER_SUCCESS] (state) {
    state.register = false;
  },
};

// actions
export const actions = {

  showLogin ({ commit }) {
    commit(types.SHOW_LOGIN_SUCCESS)
  },
  closeLogin ({ commit }) {
    commit(types.CLOSE_LOGIN_SUCCESS)
  },
  showRegister ({ commit }) {
    commit(types.SHOW_REGISTER_SUCCESS)
  },
  closeRegister ({ commit }) {
    commit(types.CLOSE_REGISTER_SUCCESS)
  },
  initLogin ({ commit }) {
    commit(types.INIT_LOGIN_SUCCESS)
  },
  initRegister ({ commit }) {
    commit(types.INIT_REGISTER_SUCCESS)
  },
};
